@tailwind base;
@tailwind components;
@tailwind utilities;

:host {
  display: block;
}

@keyframes shimmer {
  0% {
    background-position: -200px 0;
  }
  100% {
    background-position: 200px 0;
  }
}

.loading-card {
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 400px 100%;
  animation: shimmer 1.2s linear infinite;
  border-radius: 0.5rem;
  height: 100px;
  width: 100%;
}

.touch-pan-y {
  touch-action: pan-y;
}
